import classNames from 'classnames'

import './Radio.scss'

export interface RadioProps extends Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
> {
  label?: React.ReactNode
  description?: React.ReactNode
  wrapperClassName?: string
}

export const Radio: React.FC<RadioProps> = ({
  label,
  description,
  wrapperClassName,
  className,
  disabled,
  children,
  ...inputProps
}) => {
  const hasContent = label || description || children
  const ariaLabel =
    inputProps['aria-label'] ??
    (typeof label === 'string' && !inputProps['aria-labelledby']
      ? label
      : undefined)
  const radioInput = (
    <input
      {...inputProps}
      aria-label={ariaLabel}
      type="radio"
      disabled={disabled}
      className={classNames('radio__input', className)}
    />
  )

  if (!hasContent) return radioInput

  return (
    <label
      className={classNames(
        'radio',
        { 'radio--disabled': disabled },
        wrapperClassName,
      )}
    >
      {radioInput}
      <span className="radio__content">
        {children ?? (
          <>
            {label && <span className="radio__label">{label}</span>}
            {description && (
              <span className="radio__description">{description}</span>
            )}
          </>
        )}
      </span>
    </label>
  )
}
